import { formatProduct } from 'utils/storefront/format-resource';
import ShopifyUtil from 'utils/shopify-util';

const setProductsFromRecommendations = async (rec) => {
  const productsData = await Promise.all(
    rec.products.map(async (product) => {
      const productData = await ShopifyUtil.getProductData(product.product_id);
      return productData.product ? formatProduct(productData.product) : null;
    }),
  );
  return productsData;
};

const NOSTO_TIMEOUT_MS = 15000;

const getRecommendedProducts = (placements) =>
  new Promise((resolve, reject) => {
    const templateName = document.querySelector('.nosto_page_type')?.textContent || null;

    const timeoutId = setTimeout(() => {
      // console.warn('Nosto API did not load within timeout');
      resolve({ recommendations: {}, products: {} });
    }, NOSTO_TIMEOUT_MS);

    window.nostojs((api) => {
      clearTimeout(timeoutId);
      const session = api.defaultSession();
      let res;

      switch (templateName) {
        case 'front': {
          res = session.viewFrontPage();
          break;
        }
        case 'product': {
          const productId = document.querySelector('.product_id')?.textContent || null;
          res = productId ? session.viewProduct(productId) : session.viewOther();
          break;
        }
        case 'category': {
          const collectionHandle = document.querySelector('.category_string')?.textContent || null;
          res = collectionHandle ? session.viewCategory(`/${collectionHandle}`) : session.viewOther();
          break;
        }
        case 'notfound': {
          res = session.viewNotFound();
          break;
        }
        default: {
          res = session.viewOther();
        }
      }

      res
        .setPlacements(placements)
        .load()
        .then(async (response) => {
          // .update() returns recommendations under campaigns.recommendations
          const productRecommendations =
            Object.keys(response.recommendations || {}).length > 0
              ? response.recommendations
              : response.campaigns?.recommendations || {};

          if (Object.keys(productRecommendations).length === 0) {
            // console.warn('No recommendations found. Check placement ID');
            resolve({ recommendations: {}, products: {} });
            return;
          }

          const productPromises = Object.entries(productRecommendations).map(async ([placementId, rec]) => {
            const productsData = await setProductsFromRecommendations(rec);
            return { placementId, resultId: rec.result_id, productsData };
          });

          const updatedProductsArray = await Promise.all(productPromises);
          const updatedProducts = updatedProductsArray.reduce((acc, { placementId, resultId, productsData }) => {
            const filtered = productsData.filter((data) => Boolean(data));
            acc[placementId] = filtered;
            acc[resultId] = filtered;
            return acc;
          }, {});

          resolve({ recommendations: productRecommendations, products: updatedProducts });
        })
        .catch((error) => {
          reject(error);
        });
    });
  });

export default getRecommendedProducts;
